var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5 grey lighten-4 elevation-2 rounded-pill mx-2",staticStyle:{"font-size":"20px","hyphens":"auto","width":"fit-content","padding":"5px"}},[_c('v-avatar',{staticClass:"mr-2 elevation-2",attrs:{"size":"34","color":"white"}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "+_vm._s(_vm.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }